import { render, staticRenderFns } from "./RelationDetail.vue?vue&type=template&id=35e0140c&scoped=true&"
import script from "./RelationDetail.vue?vue&type=script&lang=js&"
export * from "./RelationDetail.vue?vue&type=script&lang=js&"
import style0 from "./RelationDetail.vue?vue&type=style&index=0&id=35e0140c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0140c",
  null
  
)

export default component.exports